import { notification } from '../components/util-components/FeedbackProvider'

export const openNotification =
  type =>
  ({ key, message, description = undefined }) => {
    notification[type]({
      key,
      message,
      description,
      closeIcon: false,
      duration: 2,
    })
  }

export const openSuccessNotification = openNotification('success')
export const openErrorNotification = openNotification('error')
